import { ReactNode, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectCurrentUser } from '@/redux/auth/auth.slice';

function RouteWrapper({ children }: { children: ReactNode }) {
  const { user, isAuthenticated } = useSelector(selectCurrentUser);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && !user?.isUserSignupComplete) {
      navigate('/signup');
    }
  }, [user, isAuthenticated, navigate]);

  return children;
}

export default RouteWrapper;
